export default __webpack_public_path__ + "static/0288-1cbc3c3bb33c679ed0df22d1415d6357.png";